var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSwarmSession(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#696969",
    width: "800px",
    height: "800px",
    viewBox: "0 0 52 52",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,11.48c0,.08.08.16.08.24A.29.29,0,0,0,19,11.48Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.05,11.48c0,.08.08.16.08.24a4.29,4.29,0,0,0,.4.88,6.88,6.88,0,0,0,12.06.47A16.4,16.4,0,0,1,42.28,25.45c.32,0,.64-.08.88-.08A12.35,12.35,0,0,1,47,26,20.84,20.84,0,0,0,32.55,8.6a6.5,6.5,0,0,0-.72-2.31,7,7,0,0,0-9.34-3,6.86,6.86,0,0,0-3.76,7.42A5.52,5.52,0,0,1,19.05,11.48Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.14,33.75A6.86,6.86,0,0,0,9.71,30a8.23,8.23,0,0,1-.08-1.44,16.84,16.84,0,0,1,6.23-12.93,10,10,0,0,0-.64-1,13.25,13.25,0,0,1-1.12-3.43A21.13,21.13,0,0,0,4.92,28.56c0,.88.08,1.68.16,2.56a7,7,0,1,0,10.06,2.63Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.23,33.75a6.94,6.94,0,0,0-12.37,6.31c.08.16.24.4.32.56A16.36,16.36,0,0,1,26,45a16.65,16.65,0,0,1-7.42-1.84,10.24,10.24,0,0,1-3.36,3.35,20.67,20.67,0,0,0,10.86,3,21.14,21.14,0,0,0,14.85-6.15,6.31,6.31,0,0,0,5.35-.4A6.75,6.75,0,0,0,49.23,33.75Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.13,34.15a.32.32,0,0,0,.4.4l2.64-1a.49.49,0,0,1,.56.08,6.34,6.34,0,0,0,3.67,1,7.13,7.13,0,0,0,7.34-6.87A7.13,7.13,0,0,0,26.4,20.9a7.12,7.12,0,0,0-7.27,6.86A7.41,7.41,0,0,0,20,31a.7.7,0,0,1,.08.56Z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwarmSession);
export default __webpack_public_path__ + "static/media/swarm-session.2279d6689b3341e6c61553021c794447.svg";
export { ForwardRef as ReactComponent };